<template>
  <div id="mobileCaseMgmt">

    <div class="m-search-block">
      <div class="m-search-header" @click="searchExpanded = !searchExpanded">
        <span><i class="el-icon-search"></i> 搜尋條件</span>
        <i :class="searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </div>
      <el-collapse-transition>
        <div v-show="searchExpanded" class="m-search-body">
          <div class="m-field-row m-field-row--two">
            <div v-if="btnDivVisible" class="m-inline-item">
              <label>區處分行</label>
              <DivSelection
                v-model="selectedDiv"
                :noDivision="true"
                :filterDivisionCode="filterDivisionCode"
                @branch-selected="handleDivChange"
                class="m-inline-ctrl"
              />
            </div>
            <div v-if="btnUserVisible" class="m-inline-item">
              <label>承辦人</label>
              <el-select v-model="listQuery.UserID" placeholder="請選擇承辦人" clearable class="m-inline-ctrl">
                <el-option label="全部" value="全部"></el-option>
                <el-option v-for="item in branchStaffList" :key="item.ID" :label="item.UserName" :value="item.UserID"></el-option>
              </el-select>
            </div>
          </div>

          <div class="m-field-row m-field-row--three">
            <div class="m-inline-item">
              <label>資料來源</label>
              <el-select v-model="listQuery.Source" placeholder="請選擇資料來源" clearable class="m-inline-ctrl">
                <el-option label="全部" value="全部"></el-option>
                <el-option label="總行派案" value="總行派案"></el-option>
                <el-option label="續約重訂" value="續約重訂"></el-option>
                <el-option label="自行開發" value="自行開發"></el-option>
              </el-select>
            </div>
            <div class="m-inline-item">
              <label>訪視進度</label>
              <el-select v-model="listQuery.Case_Prog" placeholder="請選擇訪視進度" clearable class="m-inline-ctrl">
                <el-option label="全部" value="全部"></el-option>
                <el-option label="已訪視完成" value="已訪視完成"></el-option>
                <el-option label="尚未訪視完成" value="尚未訪視完成"></el-option>
              </el-select>
            </div>
            <div class="m-inline-item">
              <label>案件狀態</label>
              <el-select v-model="listQuery.Case_Status" placeholder="請選擇案件狀態" clearable class="m-inline-ctrl">
                <el-option label="全部" value="全部"></el-option>
                <el-option label="1.待分派" value="待分派"></el-option>
                <el-option label="2.待安排訪視" value="待安排訪視"></el-option>
                <el-option label="3.已安排訪視" value="已安排訪視"></el-option>
                <el-option label="4.客戶拒絕" value="客戶拒絕"></el-option>
                <el-option label="5.其他" value="其他"></el-option>
                <el-option label="6.已訪視" value="已訪視"></el-option>
                <el-option label="7.撤件" value="撤件"></el-option>
                <el-option label="8.續行申貸" value="續行申貸"></el-option>
                <el-option label="9.核准" value="核准"></el-option>
              </el-select>
            </div>
          </div>

          <div class="m-field-row m-field-row--three">
            <div class="m-inline-item">
              <label>專案名稱</label>
              <el-select v-model="listQuery.Project_Name" placeholder="請選擇專案名稱" clearable class="m-inline-ctrl" @visible-change="onProjectDropdownVisible">
                <el-option label="全部" value="全部"></el-option>
                <el-option v-for="item in projectNameList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </div>
            <div class="m-inline-item m-inline-item--date">
              <label>到期日</label>
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="開始日期"
                end-placeholder="結束日期"
                class="m-inline-ctrl"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </div>
            <div class="m-inline-item">
              <label>關鍵字</label>
              <el-input v-model="keyword" placeholder="公司名稱 / 統一編號" clearable class="m-inline-ctrl"></el-input>
            </div>
          </div>

          <div class="m-inline-action">
            <el-button type="primary" icon="el-icon-search" @click="doSearch">查詢</el-button>
            <!-- <el-button type="danger" icon="el-icon-tickets" @click="exportExcel" >匯出</el-button> -->
          </div>
        </div>
      </el-collapse-transition>
    </div>

    <div class="m-toolbar" v-if="selectedIds.length > 0">
      <span class="m-sel-count">已選 {{ selectedIds.length }} 筆</span>
      <el-button size="mini" type="warning" @click="exportExcel">
        <i class="el-icon-download"></i> 匯出
      </el-button>
      <el-button size="mini" @click="clearSelection">清除</el-button>
    </div>

    <div class="m-card-list" v-loading="loading">
      <div v-if="tableData.length === 0 && !loading" class="m-empty">暫無資料</div>

      <div v-for="row in tableData" :key="row.ID" class="m-case-card" :class="{ 'is-selected': selectedIds.includes(row.ID) }">
        <div class="m-card-top">
          <el-checkbox :value="selectedIds.includes(row.ID)" @change="toggleSelect(row)" @click.native.stop></el-checkbox>
          <div class="m-case-main" >            
            <div class="m-case-companyid" @click="doShowCompanyDetail(row)">{{ row.UniComNm }}</div>
            <div class="m-case-company" @click="doshowDetail(row)">{{ row.ComName }}</div>
            
          </div>
          <div class="m-card-actions">
            <el-button size="mini" type="primary" plain @click="btnOpDetail(row)">明細</el-button>            
          </div>
        </div>

        <div class="m-card-meta">
          <span class="m-meta-item"><i class="el-icon-document"></i> {{ row.CaseNo  }}</span>
          <span class="m-meta-item"><i class="el-icon-s-data"></i> {{ row.Source  }}</span>
          <span class="m-meta-item"><i class="el-icon-folder"></i> {{ row.ProjectName  }}</span>
          <span class="m-meta-item"><i class="el-icon-date"></i> {{ row.CloseDt  }} {{ formatExpectVisitDisplay(row)  }}</span>          
          <span class="m-meta-item"><i class="el-icon-user"></i> {{ row.AssigneeUserName  }}</span>
          <el-tag size="mini" type="info">{{ row.CaseStatus  }}</el-tag>
          <el-tag size="mini" :type="approvedTagType(row.ApprovedStatus)">{{ row.ApprovedStatus  }}</el-tag>
        </div>
      </div>
    </div>

    <div class="m-page-bar">
      <Pagination
        @currentChange="pageChange"
        :pageSize="listQuery.Page_Size"
        :propsCurrentPage="listQuery.Page_Num"
        :totalLists="totalLists"
      ></Pagination>
    </div>

    <el-dialog title="案件明細" :visible.sync="dialogVisible" width="95%" center :close-on-click-modal="false" @close="closeDialog">
      <div class="m-dialog-form" v-if="details">
        <div class="m-form-item"><label>案件編號</label><span>{{ details.CaseNo  }}</span></div>
        <div class="m-form-item"><label>到期日/限辦日期</label><span>{{ details.DueDt  }}</span></div>
        <div class="m-form-item"><label>統一編號</label><span>{{ details.UniComNm  }}</span></div>
        <div class="m-form-item"><label>公司名稱</label><span>{{ details.ComName  }}</span></div>
        <div class="m-form-item"><label>資料來源</label><span>{{ details.Source  }}</span></div>
        <div class="m-form-item"><label>專案名稱</label><span>{{ details.ProjectName  }}</span></div>

        <div class="m-form-item col-span-2">
          <label>案件狀態</label>
          <div style="flex:1; display:flex; align-items:center;">
            <el-select :disabled="!editDetail" v-model="details.CaseStatus" placeholder="請選擇案件狀態" @change="checkReason" style="width:35%">
              <el-option v-for="(opt, idx) in nextSelectList" :key="idx" :value="opt"></el-option>
            </el-select>

            <el-select :disabled="!showReason || !editDetail" v-model="details.CaseReason" placeholder="請選擇原因" @change="checkOther" style="margin-left:10px; width:35%;">
              <el-option v-for="(opt, idx) in selectedReason" :key="idx" :label="opt" :value="opt"></el-option>
            </el-select>

            <el-input type="input" :disabled="!editDetail || details.CaseReason !== '其他'" v-model="details.CaseReasonDescription" placeholder="請說明原因..." style="margin-left:10px; width:100%;"></el-input>
          </div>
        </div>

        <div class="m-form-item radio-row">
          <label style="width:150px">預計訪視時間</label>
          <div style="flex:1; display:flex; align-items:center;flex-direction: row;">
            <div style="flex:0 0 50%; padding-right:0.75rem;">
              <el-date-picker :disabled="!editDetail" v-model="details.ExpectVisitDt" type="date" value-format="yyyy-MM-dd" placeholder="選擇日期" style="width:100%;"></el-date-picker>
            </div>
            <div style="flex:0 0 50%; display:flex; align-items:center; justify-content:flex-start;">
              <el-radio :disabled="!editDetail" v-model="details.vTime" label="10" >上午</el-radio>
              <el-radio :disabled="!editDetail" v-model="details.vTime" label="14">下午</el-radio>
            </div>
          </div>
        </div>

        <div class="m-form-item"><label>區處</label><span>{{ details.DivisionName  }}</span></div>
        <div class="m-form-item"><label>分行名稱</label><span>{{ details.DeptName  }}</span></div>

        <div class="m-form-item" v-if="reFieldVisible"><label>ELN編號</label><span>{{ details.ELNNo  }}</span></div>
        <div class="m-form-item" v-if="reFieldVisible"><label>餘額</label><span>{{ details.CurrentAmount  }}</span></div>

        <div class="m-form-item" v-if="hqFieldVisible"><label>信評等級</label><span>{{ details.CreditRating  }}</span></div>
        <div class="m-form-item" v-if="hqFieldVisible"><label>資本額</label><span>{{ details.CapitalAmount  }}</span></div>
        <div class="m-form-item" v-if="hqFieldVisible"><label>員工人數</label><span>{{ details.EmployeeCount  }}</span></div>
        <div class="m-form-item" v-if="hqFieldVisible"><label>台幣放款戶(Y/N)</label><span>{{ details.TwdLoanAccountYN  }}</span></div>
        <div class="m-form-item" v-if="hqFieldVisible"><label>有外幣存款(Y/N)</label><span>{{ details.FxDepositAccountYN  }}</span></div>
        <div class="m-form-item" v-if="hqFieldVisible"><label>衍生性金融商品(Y/N)</label><span>{{ details.DerivativeProductYN  }}</span></div>
        <div class="m-form-item" v-if="hqFieldVisible"><label>近一年貢獻度(千元)</label><span>{{ details.LastYearContribution  }}</span></div>
        <div class="m-form-item" v-if="hqFieldVisible"><label>外匯存款AUM(千元)</label><span>{{ details.FxDepositAUM  }}</span></div>
        <div class="m-form-item" v-if="hqFieldVisible"><label>AUM</label><span>{{ details.TotalAUM  }}</span></div>

        <div class="m-form-item"><label>覆核主管</label><span>{{ details.ApproveUserName  }}</span></div>        

        <div class="m-form-item">
          <label>承辦人</label>
          <div class="m-inline-stack" style="flex:1;">
            <span>{{ details.AssigneeUserName  }}</span>
            <el-select v-if="assignBtnVisible" v-model="seletedStaff" placeholder="變更承辦人" clearable @change="changeStaff" style="width:100%;">
              <el-option v-for="item in branchStaffList" :key="item.ID" :label="`${item.UserName} (${item.RoleName})`" :value="item.ID"></el-option>
            </el-select>
          </div>
        </div>

        <div class="m-form-item"><label>建立時間</label><span>{{ details.CreateDt  }}</span></div>

        <div class="m-form-item">
          <label>備註</label>
          <el-input :disabled="!editDetail" v-model="details.Memo" type="textarea" :rows="1" style="flex:1;"></el-input>
        </div>

        <div class="m-form-item" v-if="hqFieldVisible"><label>備註1</label><span>{{ details.Memo1  }}</span></div>
        <div class="m-form-item" v-if="hqFieldVisible"><label>備註2</label><span>{{ details.Memo2  }}</span></div>
        <div class="m-form-item" v-if="hqFieldVisible"><label>備註3</label><span>{{ details.Memo3  }}</span></div>
      </div>

      <span slot="footer" class="m-dialog-footer">
        <el-button type="primary" @click="showCaseHistory">案件歷程</el-button>
        <el-button v-if="editBtnVisible && !submitOrNot" type="primary" @click="btnEditDetail">編輯</el-button>
        <el-button v-if="saveBtnVisible" type="success" @click="btnSaveDetail">{{ btnSaveTitle }}</el-button>
        <el-button v-if="assignBtnVisible" type="primary" @click="assignBtn">{{ assignBtnTitle }}</el-button>
        <el-button v-if="btnApprove" type="success" @click="apprBtn">覆核</el-button>
        <el-button v-if="btnApprove" type="danger" @click="rejectBtn">退回</el-button>
        <el-button @click="closeDialog">關閉</el-button>
      </span>
    </el-dialog>

    <el-dialog title="案件歷程" :visible.sync="historyDrawerVisible" width="95%" center>
      <el-table :data="caseHistoryData" size="mini" border stripe style="width:100%">
        <el-table-column prop="TriggerDt" label="建立時間" min-width="150" :formatter="formatDateTimeToMinute"></el-table-column>
        <el-table-column prop="ActionType" label="類型" min-width="120"></el-table-column>
        <el-table-column prop="TriggerUserName" label="異動人" min-width="100"></el-table-column>
        <el-table-column prop="AssigneeUserName" label="承辦人" min-width="100"></el-table-column>
        <el-table-column prop="Memo" label="備註" min-width="150"></el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="historyDrawerVisible = false">關閉</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import Pagination from '../../../components/Pagination.vue';
import DivSelection from '../../../components/DivSelection.vue';
import { notify, handleError } from '../../../utils/notify';
import ExcelJS from 'exceljs';

export default {
  name: 'MobileCaseMgmt',
  components: { Pagination, DivSelection },

  data() {
    return {
      searchExpanded: true,
      loading: false,

      btnDivVisible: false,
      btnUserVisible: false,
      assignBtnVisible: false,
      editBtnVisible: false,
      btnApprove: false,

      assignBtnTitle: '指派',
      btnSaveTitle: '儲存',
      submitOrNot: false,
      saveBtnVisible: false,

      hqFieldVisible: false,
      reFieldVisible: false,

      filterDivisionCode: '',
      selectedDiv: [],
      branchStaffList: [],
      projectNameList: [],
      seletedStaff: '',

      tableData: [],
      totalLists: 0,

      selectedIds: [],
      selectedMap: {},

      keyword: '',
      dateRange: [],
      listQuery: {
        Page_Size: 10,
        Page_Num: 1,
        Case_Prog: '尚未訪視完成',
        Source: '全部',
        Case_Status: '全部',
        Project_Name: '全部',
        UserID: '全部',
      },

      pickerOptions: {
        shortcuts: [
          {
            text: '最近一週',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一個月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三個月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },

      dialogVisible: false,
      historyDrawerVisible: false,
      caseHistoryData: [],
      selectedRow: null,
      details: {},
      editDetail: false,
      showReason: false,
      selectedReason: [],
      nextSelectList: [],

      status_transion: [
        { '待安排訪視': ['待安排訪視', '客戶拒絕', '其他', '已安排訪視'] },
        { '已安排訪視': ['已安排訪視', '已訪視'] },
        { '已訪視': ['已訪視', '撤件', '續行申貸', '已安排訪視'] },
      ],
      ReasonList: [
        { 客戶拒絕: ['對產品/服務不感興趣', '要求特定時間再聯繫', '暫無資金需求', '已有往來行庫', '其他'] },
        { 其他: ['重覆名單', '聯絡方式錯誤', '聯絡不上', '停歇業', '其他'] },
        { 撤件: ['訪談後無意願', '要求特定時間再聯繫', '其他'] },
      ],
    };
  },

  methods: {
    doshowDetail(row) { 
      this.$queryRecord && this.$queryRecord(this, row.ComName, 'company');
      const url = `/ctmMapCom?unicomnm=${row.UniComNm}`;
      window.open(url, '_blank');            
      // const routeData = this.$router.resolve({
      //   name: 'm-ctm-map-com',
      //   query: { unicomnm: row.UniComNm },
      // });
      // window.open(routeData.href, '_blank'); 
    },

    toggleSelect(row) {
      const idx = this.selectedIds.indexOf(row.ID);
      if (idx === -1) {
        this.selectedIds.push(row.ID);
        this.selectedMap[row.ID] = row;
      } else {
        this.selectedIds.splice(idx, 1);
        delete this.selectedMap[row.ID];
      }
    },

    clearSelection() {
      this.selectedIds = [];
      this.selectedMap = {};
    },

    getSelectedCases() {
      return Object.values(this.selectedMap);
    },

    async exportExcel() {
      if (!this.tableData || this.tableData.length === 0) {
        notify({
          title: '錯誤',
          message: '目前無資料可匯出',
          type: 'error'
        });
        return;
      }

      try {
        const rows = this.getSelectedCases() || [];
        if (!rows || rows.length === 0) {
          notify({ title: '警告', message: '請先勾選要匯出的案件', type: 'warning' });
          return;
        }

        const exportData = rows.map(r => ({
          '案件編號': r.CaseNo || '',
          '案件狀態': r.CaseStatus || '',
          '案件原因': r.CaseReason || '',
          '原因說明': r.CaseReasonDescription || '',
          '覆核狀態': r.ApprovedStatus || '',
          '區處': r.DivisionName || '',
          '分行名稱': r.DeptName || '',
          '承辦人': r.AssigneeUserName || '',
          '預計訪視時間': r.ExpectVisitDt || '',
          '統一編號': r.UniComNm || '',
          '公司名稱': r.ComName || '',
          '資料來源': r.Source || '',
          '專案名稱': r.ProjectName || '',
          '到期日/限辦日期': r.CloseDt || '',
          '備註': r.Memo || '',
          '建立時間': r.CreateDt || ''
        }));

        const exportUniComNms = exportData.slice(0, 10).map(d => d['統一編號']).join(', ');

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('案件');
        worksheet.columns = [
          { header: '案件編號', key: '案件編號', width: 16 },
          { header: '案件狀態', key: '案件狀態', width: 16 },
          { header: '案件原因', key: '案件原因', width: 16 },
          { header: '原因說明', key: '原因說明', width: 24 },
          { header: '覆核狀態', key: '覆核狀態', width: 14 },
          { header: '區處', key: '區處', width: 14 },
          { header: '分行名稱', key: '分行名稱', width: 16 },
          { header: '承辦人', key: '承辦人', width: 14 },
          { header: '預計訪視時間', key: '預計訪視時間', width: 16 },
          { header: '統一編號', key: '統一編號', width: 16 },
          { header: '公司名稱', key: '公司名稱', width: 24 },
          { header: '資料來源', key: '資料來源', width: 14 },
          { header: '專案名稱', key: '專案名稱', width: 20 },
          { header: '到期日/限辦日期', key: '到期日/限辦日期', width: 18 },
          { header: '備註', key: '備註', width: 24 },
          { header: '建立時間', key: '建立時間', width: 18 }
        ];
        worksheet.addRows(exportData);

        const now = new Date();
        const ts = `${now.getFullYear()}${String(now.getMonth()+1).padStart(2,'0')}${String(now.getDate()).padStart(2,'0')}_${String(now.getHours()).padStart(2,'0')}${String(now.getMinutes()).padStart(2,'0')}`;
        const filename = `案件列表_${ts}.xlsx`;

        const excelBuffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        const setAudit = {
          "menu_path": ["客戶名單管理", "案件管理"],
          "action_type": "export",
          "action_name": "匯出",
          "details": {
            "UniComNms": exportUniComNms,
            "exported_count": exportData.length
          }
        };
        await this.$api.apimgrs.setAuditLog(setAudit);

        notify({ title: '成功', message: `已下載 ${filename}`, type: 'success' });
      } catch (err) {
        console.error('匯出 Excel 發生錯誤', err);
        notify({ title: '錯誤', message: '匯出失敗，請稍後再試', type: 'error' });
      }
    },

    approvedTagType(status) {
      if (status === '已覆核') return 'success';
      if (status === '待覆核') return 'warning';
      if (status === '退回承辦') return 'danger';
      return 'info';
    },

    formatExpectVisitDisplay(row) {
      if (!row || !row.ExpectVisitDt) return '';
      const dateText = String(row.ExpectVisitDt).split('T')[0];
      const rawStartTime = row.ExpectVisitStartTime || row.Expect_Visit_Start_Time || '';
      const hour = parseInt(String(rawStartTime).split(':')[0], 10);
      const period = !Number.isNaN(hour) && hour >= 12 ? '下午' : '上午';
      return `${dateText} ${period}`;
    },

    formatDateTimeToMinute(row, column, cellValue) {
      const value = cellValue || (row && column && row[column.property]) || '';
      if (!value) return '';
      const text = String(value).replace('T', ' ').trim();
      return text.length >= 16 ? text.slice(0, 16) : text;
    },

    handleDivChange(val) {
      this.listQuery.DivisionCode = val.DivisionCode;
      this.listQuery.DeptID = val.DeptID;
    },

    onProjectDropdownVisible(visible) {
      if (visible) this.clickLoadProjectName();
    },

    async doSearch() {
      this.listQuery.Page_Num = 1;
      if (this.keyword && this.keyword.trim()) {
        this.$queryRecord(this, this.keyword, 'keyword');
      }
      await this.getList();
    },

    async pageChange(val) {
      this.listQuery.Page_Num = val;
      await this.getList();
    },

    normalizeCaseStatus(item) {
      switch (item.CaseStatus) {
        case '待分派': return '1.待分派';
        case '待安排訪視': return '2.待安排訪視';
        case '已安排訪視': return '3.已安排訪視';
        case '客戶拒絕': return '4.客戶拒絕';
        case '其他': return '5.其他';
        case '已訪視': return '6.已訪視';
        case '撤件': return '7.撤件';
        case '續行申貸': return '8.續行申貸';
        case '核准': return '9.核准';
        default: return item.CaseStatus || '';
      }
    },

    normalizeApprovedStatus(item) {
      if (item.ApprovedStatus === 'approved') return '已覆核';
      if (item.ApprovedStatus === 'rejected') return '退回承辦';
      if (item.ApprovedStatus === 'pending') return '待覆核';
      return item.ApprovedStatus || '';
    },

    async getList() {
      this.loading = true;
      const qry = {
        Page_Size: this.listQuery.Page_Size,
        Page_Num: this.listQuery.Page_Num,
      };

      if (this.selectedDiv && this.selectedDiv.length > 0) {
        qry.DeptID = this.selectedDiv[1];
        qry.Division_Code = this.selectedDiv[0];
      }
      if (this.keyword && this.keyword.trim()) qry.Keyword = this.keyword.trim();
      if (this.listQuery.Source && this.listQuery.Source !== '全部') qry.Source = this.listQuery.Source;
      if (this.listQuery.Project_Name && this.listQuery.Project_Name !== '全部') qry.Project_Name = this.listQuery.Project_Name;
      if (this.listQuery.Case_Status && this.listQuery.Case_Status !== '全部') qry.Case_Status = [this.listQuery.Case_Status];
      if (this.listQuery.UserID && this.listQuery.UserID !== '全部') qry.Assignee_User_ID = this.listQuery.UserID;

      if (this.listQuery.Case_Prog === '已訪視完成') qry.IsCompleted = 'Y';
      if (this.listQuery.Case_Prog === '尚未訪視完成') qry.IsCompleted = 'N';

      if (this.dateRange && this.dateRange.length === 2) {
        qry.Due_START = this.dateRange[0].toISOString().split('T')[0];
        qry.Due_END = this.dateRange[1].toISOString().split('T')[0];
      }

        console.log('Querying case list with:', qry);
      try {
        const response = await this.$api.apicase.case_list(qry);
        const list = (response.data || []).map(item => ({
          ...item,
          CaseStatus: this.normalizeCaseStatus(item),
          ApprovedStatus: this.normalizeApprovedStatus(item),
        }));
        this.tableData = list;
        this.totalLists = response.total || 0;

        const nextSelectedMap = { ...this.selectedMap };
        list.forEach(row => {
          if (Object.prototype.hasOwnProperty.call(nextSelectedMap, row.ID)) {
            nextSelectedMap[row.ID] = row;
          }
        });
        this.selectedMap = nextSelectedMap;
        this.selectedIds = Object.values(nextSelectedMap)
          .map(item => item && item.ID)
          .filter(id => id !== undefined && id !== null);
      } catch (error) {
        notify({ title: '錯誤', message: '獲取案件列表失敗，請稍後再試', type: 'error' });
      } finally {
        this.loading = false;
      }
    },

    async btnOpDetail(row) {
      this.selectedRow = row;
      try {
        const response = await this.$api.apicase.case_detail({ ID: row.ID });
        const data = response.data || {};
        const rawStartTime = data.ExpectVisitStartTime || data.Expect_Visit_Start_Time || '';
        const hour = parseInt(String(rawStartTime).split(':')[0], 10);
        this.details = {
          ...data,
          vTime: !Number.isNaN(hour) && hour >= 12 ? '14' : '10',
        };

        // 根據資料來源決定要顯示哪些欄位（與桌機版一致）
        this.hqFieldVisible = data.Source === '總行派案';
        this.reFieldVisible = data.Source === '續約重訂';

        this.nextSelectList = [];
        for (let i = 0; i < this.status_transion.length; i += 1) {
          const key = Object.keys(this.status_transion[i])[0];
          if (key === data.CaseStatus) {
            this.nextSelectList = this.status_transion[i][key];
            break;
          }
        }

        const roleName = window.localStorage.getItem('userRole') || '';
        this.submitOrNot = data.ApprovedStatus === 'pending' || data.ApprovedStatus === 'approved';
        this.btnApprove = roleName.includes('UC') && data.ApprovedStatus === 'pending';

        if (data.CaseStatus === '待分派') {
          this.assignBtnTitle = '指派';
        } else {
          this.assignBtnTitle = '改派';
        }

        // console.log('ApprovedStatus:', data.ApprovedStatus, 'roleName', roleName, 'assignBtnVisible:', this.assignBtnVisible);
        // UC角色, 若案件"覆核後"及"待覆核"不該再能編輯，包括改派
        if( roleName=='UC' && (data.ApprovedStatus == "approved" || data.ApprovedStatus == "pending" ) ){
            this.assignBtnVisible = false;
        }        
        // console.log('ApprovedStatus:', data.ApprovedStatus, 'roleName', roleName, 'assignBtnVisible:', this.assignBtnVisible);
        


        const userHasEditPermission = this.$store.getters.userMenu
          ?.find(item => item.Name === '案件管理')?.Action
          ?.some(item => item.Action === '修改案件') || false;
        this.editBtnVisible = userHasEditPermission && !this.submitOrNot;

        this.showReason = false;
        this.selectedReason = [];
        this.saveBtnVisible = false;
        this.editDetail = false;
        this.dialogVisible = true;
      } catch (error) {
        notify({ title: '錯誤', message: '獲取案件詳細資訊失敗，請稍後再試', type: 'error' });
      }
    },

    btnEditDetail() {
      this.editDetail = true;
      this.details.CaseStatus = '';
      this.saveBtnVisible = true;
      this.editBtnVisible = false;
    },

    checkReason() {
      this.showReason = false;
      this.selectedReason = [];

      for (let i = 0; i < this.ReasonList.length; i += 1) {
        const key = Object.keys(this.ReasonList[i])[0];
        if (this.details && this.details.CaseStatus && key === this.details.CaseStatus) {
          this.showReason = true;
          this.selectedReason = this.ReasonList[i][key];
          break;
        }
      }

      if (['客戶拒絕', '撤件', '續行申貸', '其他'].includes(this.details.CaseStatus)) {
        this.btnSaveTitle = '申請覆核並儲存';
      } else {
        this.btnSaveTitle = '儲存';
      }

      if (!this.showReason && this.details.CaseReason) {
        this.details.CaseReason = '';
      }
    },

    checkOther() {
      // placeholder for parity with 桌機版，若需額外邏輯可在此擴充
    },

    async btnSaveDetail() {
      if (!this.details.CaseStatus) {
        notify({ title: '錯誤', message: '案件狀態不能為空', type: 'error' });
        return;
      }
      if (this.showReason && !this.details.CaseReason) {
        notify({ title: '錯誤', message: '請選擇變更原因', type: 'error' });
        return;
      }
      if (this.details.CaseStatus === '已安排訪視' && !this.details.ExpectVisitDt) {
        notify({ title: '錯誤', message: '當案件狀態為已安排訪視時，預計訪視時間不能為空', type: 'error' });
        return;
      }
      if (this.showReason && this.details.CaseReason === '其他' && !this.details.CaseReasonDescription) {
        notify({ title: '錯誤', message: '請填寫其他原因的說明', type: 'error' });
        return;
      }

      try {
        const isPm = String(this.details.vTime || '10') === '14';
        const visitStartTime = isPm ? '14:00' : '10:00';
        const visitEndTime = isPm ? '16:00' : '12:00';
        await this.$api.apicase.case_update({
          ID: this.selectedRow.ID,
          Case_Status: this.details.CaseStatus,
          Expect_Visit_Dt: this.details.ExpectVisitDt,
          Expect_Visit_Start_Time: this.details.ExpectVisitDt ? visitStartTime : '',
          Expect_Visit_End_Time: this.details.ExpectVisitDt ? visitEndTime : '',
          Memo: this.details.Memo,
        });

        if (this.showReason || this.details.CaseStatus === '續行申貸') {
          await this.$api.apicase.case_submit_approval({
            ID: this.selectedRow.ID,
            Case_Reason: this.details.CaseReason || '',
            Case_Reason_Description: this.details.CaseReasonDescription || '',
          });
        }

        notify({ title: '成功', message: '案件明細已更新', type: 'success' });
        this.dialogVisible = false;
        await this.getList();
      } catch (error) {
        notify({ title: '錯誤', message: '更新案件明細失敗，請稍後再試', type: 'error' });
      }
    },

    async assignBtn() {
      if (!this.seletedStaff) {
        notify({ title: '警告', message: '請選擇承辦人', type: 'warning' });
        return;
      }
      if (!this.selectedRow || !this.selectedRow.ID) {
        notify({ title: '錯誤', message: '無法取得案件編號', type: 'error' });
        return;
      }

      const staff = this.branchStaffList.find(item => item.ID === this.seletedStaff);
      if (!staff) {
        notify({ title: '錯誤', message: '查無承辦人資料', type: 'error' });
        return;
      }

      const qry = {
        ID: this.selectedRow.ID,
        Assignee_User_ID: staff.UserID,
        Assignee_User_Name: staff.UserName,
      };

      if (this.assignBtnTitle === '指派') {
        qry.Is_Reassign = false;
      }
      if (this.assignBtnTitle === '改派') {
        qry.Is_Reassign = true;
      }

      try {
        await this.$api.apicase.case_assign(qry);
        notify({ title: '成功', message: '案件指派成功', type: 'success' });
        this.dialogVisible = false;
        await this.getList();
      } catch (error) {
        notify({ title: '錯誤', message: '案件指派失敗，請稍後再試', type: 'error' });
      }
    },

    changeStaff() {
      const staff = this.branchStaffList.find(item => item.ID === this.seletedStaff);
      if (staff && this.details) {
        this.details.AssigneeUserName = staff.UserName;
      }
    },

    async apprBtn() {
      try {
        await this.$api.apicase.case_approve({ ID: this.selectedRow.ID, Approved_Status: 'approved' });
        notify({ title: '成功', message: '案件覆核成功', type: 'success' });
        this.dialogVisible = false;
        await this.getList();
      } catch (error) {
        notify({ title: '錯誤', message: '案件覆核失敗，請稍後再試', type: 'error' });
      }
    },

    async rejectBtn() {
      try {
        await this.$api.apicase.case_approve({ ID: this.selectedRow.ID, Approved_Status: 'rejected' });
        notify({ title: '成功', message: '案件已退回承辦', type: 'success' });
        this.dialogVisible = false;
        await this.getList();
      } catch (error) {
        notify({ title: '錯誤', message: '案件退回失敗，請稍後再試', type: 'error' });
      }
    },

    async showCaseHistory() {
      if (!this.selectedRow || !this.selectedRow.ID) {
        notify({ title: '錯誤', message: '無法取得案件編號', type: 'error' });
        return;
      }
      try {
        const response = await this.$api.apicase.case_history({
          CaseID: this.selectedRow.ID,
          Page_Size: 10,
          Page_Num: 1,
        });
        this.caseHistoryData = response.data || [];
        this.historyDrawerVisible = true;
      } catch (error) {
        notify({ title: '錯誤', message: '取得案件歷程失敗，請稍後再試', type: 'error' });
      }
    },

    closeDialog() {
      this.editDetail = false;
      this.saveBtnVisible = false;
      this.hqFieldVisible = false;
      this.reFieldVisible = false;
      const userHasEditPermission = this.$store.getters.userMenu
        ?.find(item => item.Name === '案件管理')?.Action
        ?.some(item => item.Action === '修改案件') || false;
      this.editBtnVisible = userHasEditPermission && !this.submitOrNot;
      this.dialogVisible = false;
    },

    async doShowCompanyDetail(data) {
        console.log(data);
        const comid = data.UniComNm;
        const comname = data.ComName;

        this.$queryRecord(this, comname, 'company');  // 記錄點擊公司名
        // 開啟新視窗, 顯示公司詳細資訊
        const url = `/companyDetail?comid=${comid}&comname=${comname}`;
        window.open(url, '_blank');		
        
    },   



    clickLoadProjectName() {
      const roleName = this.$store.getters.userRole || '';
      if (roleName.includes('UC') || roleName.includes('HD') || roleName.includes('HC') || roleName.includes('HE') || roleName.includes('HC1')) {
        const qry = { isSys: true };
        if (this.selectedDiv && this.selectedDiv.length > 0) {
          qry.DeptID = this.selectedDiv[1];
        }
        this.$api.apicase.case_project_options(qry).then(response => {
          this.projectNameList = response.data || [];
        }).catch(() => {
          notify({ title: '錯誤', message: '獲取專案名稱失敗，請稍後再試', type: 'error' });
        });
      }
    },

    loadProjectNameList() {
      const qry = { isSys: true };
      const userInfo = this.$store.getters.userInfo || {};
      const roleName = this.$store.getters.userRole || '';
      if (roleName.includes('UC')) qry.DeptID = userInfo.DeptID;
      if (roleName.includes('UAO')) qry.UserID = userInfo.UserID;

      this.$api.apicase.case_project_options(qry).then(response => {
        this.projectNameList = response.data || [];
      }).catch(() => {
        notify({ title: '錯誤', message: '獲取專案名稱失敗，請稍後再試', type: 'error' });
      });
    },

    getBranchStaff() {
      const deptID = window.localStorage.getItem('deptID');
      this.$api.apidivison.contact_list_search({ DeptID: deptID, isSys: true }).then(response => {
        this.branchStaffList = response.data.filter(item => item.RoleName == "UC" || item.RoleName == "UAO") || [];
      }).catch(() => {
        notify({ title: '錯誤', message: '獲取分行承辦人清單失敗，請稍後再試', type: 'error' });
      });
    },

    async getFunctions() {
      try {
        const info = this.$store.getters.userInfo;
        if (info && info.Menu) {
          const actions = info.Menu.find(item => item.Name === '案件管理')?.Action || [];
          this.assignBtnVisible = actions.some(item => item.Action === '指派/改派案件');
          this.editBtnVisible = actions.some(item => item.Action === '修改案件');
        }

        const roleName = this.$store.getters.userRole || '';
        this.btnDivVisible = roleName.includes('HE') || roleName.includes('HC1') || roleName.includes('HD') || roleName.includes('HC');
        this.btnUserVisible = roleName.includes('UC');

        if (roleName === 'HE' || roleName === 'HC1') {
          this.filterDivisionCode = info.DivisionCode;
        }
      } catch (error) {
        notify({ title: '錯誤', message: '獲取使用者功能列表失敗，請稍後再試', type: 'error' });
      }
    },
  },

  async mounted() {
    this.$store.dispatch('loadingHandler', true);
    await this.getFunctions();
    this.getBranchStaff();
    await Promise.all([this.getList(), this.loadProjectNameList()]);

    const caseId = this.$route && this.$route.query ? this.$route.query.caseId : '';
    if (caseId) {
      await this.btnOpDetail({ ID: caseId });
      const nextQuery = { ...(this.$route.query || {}) };
      delete nextQuery.caseId;
      try {
        const replaceResult = this.$router.replace({ query: nextQuery });
        if (replaceResult && typeof replaceResult.catch === 'function') {
          replaceResult.catch(() => {});
        }
      } catch (e) {
        // ignore router replace failures for query cleanup
      }
    }

    this.$store.dispatch('loadingHandler', false);
  },
};
</script>

<style lang="scss" scoped>
$primary: #1c2d5e;
$active: #2a5caa;

#mobileCaseMgmt {
  min-height: 100vh;
  background: #f5f6fa;
  padding-bottom: 12px;

  .m-search-block {
    background: #fff;
    border-radius: 8px;
    margin: 12px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);

    .m-search-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 16px;
      font-weight: 600;
      color: $primary;
      cursor: pointer;
      user-select: none;
    }

    .m-search-body {
      padding: 0 16px 16px;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .m-field-row {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
    }

    .m-inline-item {
      flex: 1;
      min-width: 220px;
      display: flex;
      align-items: center;
      gap: 8px;

      label {
        width: 64px;
        flex-shrink: 0;
        font-size: 13px;
        color: #606266;
      }
    }

    .m-inline-item--date {
      min-width: 300px;
    }

    .m-inline-ctrl {
      flex: 1;
      min-width: 0;
    }

    .m-inline-action {
      display: flex;
      justify-content: flex-end;
    }
  }

  .m-toolbar {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    background: #fff3e0;
    border-radius: 8px;
    margin: 0 12px 8px;
    padding: 10px 12px;
    border-left: 4px solid #ff9800;

    .m-sel-count {
      font-size: 13px;
      font-weight: 600;
      color: #e65100;
    }
  }

  .m-card-list {
    padding: 0 12px;
  }

  .m-empty {
    text-align: center;
    color: #909399;
    padding: 40px 0;
    font-size: 14px;
  }

  .m-case-card {
    background: #fff;
    border-radius: 10px;
    margin-bottom: 12px;
    padding: 14px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);
    border-left: 4px solid #c8d8f8;

    &.is-selected {
      border-left-color: $active;
      background: #f0f5ff;
    }
  }

  .m-card-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  .m-card-top .m-card-actions {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
    padding-top: 0;
    border-top: none;
  }

  .m-case-main {
    display: flex;
    flex-direction: row;
    flex: 1;
    cursor: pointer;
  }

  .m-case-no {
    font-size: 15px;
    font-weight: 700;
    color: $active;
    margin-right: 1rem;
  }

  .m-case-company {
          display: block;
          font-size: 1rem;
          font-weight: 700;
          color: $active;
          margin-left: 0.5rem;
  }
  .m-case-companyid {
          display: block;
          font-size: 1rem;
          color: #909399;
  }  

  .m-card-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 10px;
    margin: 10px 0 8px 28px;

    .m-meta-item {
      font-size: 12px;
      color: #606266;

      i {
        margin-right: 3px;
        color: $primary;
      }
    }
  }

  .m-status-row {
    display: flex;
    gap: 6px;
    margin: 0 0 10px 28px;
  }



  .m-page-bar {
    padding: 8px 12px 0;
    display: flex;
    justify-content: center;
  }

  .m-dialog-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 3px 3px;

    .m-form-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      border-bottom: 1px solid #ebeef5;
      padding: 3px 0;

      label {
        width: 150px;
        min-width: 150px;
        flex-shrink: 0;
        font-size: 14px;
        color: #303133;
        text-align: left;
        padding-right: 12px;
      }

      > span {
        flex: 1;
        min-height: 32px;
        color: #606266;
        font-size: 14px;
      }
    }
    .m-form-item.col-span-2 {
      grid-column: 1 / -1;
    }

    /* 針對預計訪視時間那一列的 label 寬度覆寫，避免影響其他欄位 */
    .m-form-item.radio-row {
      label {
        width: auto;
        min-width: 0;
        flex: 0 0 auto;
      }
    }
  }

  .m-inline-stack {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .m-radio-row {
    display: flex;
    gap: 12px;
  }

  .m-dialog-footer {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-end;
  }
}

@media (max-width: 767px) {
  #mobileCaseMgmt {
    .m-search-block {
      .m-inline-item {
        min-width: 100%;
      }

      .m-inline-item--date {
        min-width: 100%;
      }
    }

    .m-dialog-footer {
      justify-content: center;
    }
  }
}
</style>
